import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

// News Card - Created on July 14, 2020 by Varun
const NewsCard = (props) => {
  const path = (props.pic)
  let pathFinal;
  if (props.pic) {
    pathFinal = "../" + path.split("static/")[1]
  } else {
    pathFinal = "../img/default.png";
  }

  // console.log(pathFinal)
  return (
    <Link style={{ textDecoration: "none" }} to={`/news/${props.slug}`}>
      <Wrapper>
        <Photo image={pathFinal} />
        <ContentWrapper>
          <Date>{props.date}</Date>
          <Title>{props.title}</Title>
          <Description>{props.description}</Description>
        </ContentWrapper>
      </Wrapper>
    </Link>
  )
}

// ********** Styled Components ********** //

const Wrapper = styled.div`
  
  // Margin & Padding
  margin: 0;
  padding: 0;
  
  // Sizing
  width: auto;
  height: 325px;
  
  min-width: 275px;
  
  // Flexbox
  display: flex;
  flex-direction: column;  
  
  // Border
  //border: 3px solid var(--primaryWhite);
  border-radius: 3px;

  box-shadow: 0 0 3px rgba(0,0,0,.15),0 2px 3px rgba(0,0,0,.15);
  
  // Color
  background-color: var(--primaryWhite);
  
  // Others
  overflow: hidden;

  transition: all 0.15s ease-in;


  :hover {
    z-index: 100;
    box-shadow:  0 5px 6px 0 rgba(0,0,0,0.18), 0 5px 6px 0 rgba(0,0,0,0.15);
  }
  // Tablet and below
  @media only screen and (max-width : 1024px) {

  }
`;

// Photo - Created on July 14, 2020
const Photo = styled.div`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  //height: 60%;
  
  // Flex
  flex-grow: 1;
  
  // Color
  background: url("${props => props.image}");
  
  
  
`;

// Content Wrapper - Created on July 14, 2020
const ContentWrapper = styled.div`
  
  // Spacing
  margin: 0;
  padding: var(--spacer-3) var(--spacer-3);
  
  min-height: 40%;
  
  // Flex
  flex-shrink: 0;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  
`;


const Title = styled.h2`

  // Margin & Padding
  margin: 0 0 var(--spacer-1) 0;
  padding: 0;
  
  // Display
  display: inline-block;
    
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-4);
  line-height: 1.25;
  
  // Color
  color: var(--textBlack);
  
  // Large phones and below
  @media only screen and (max-width : 414px) {
    //font-size: 1.2rem;
  }
`;


const Description = styled.p`
  
  // Margin & Padding
  margin: 0;
  padding: 0;
  
  // Font
  font-family: var(--bodyFont);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-3);
  line-height: 1.25;
  
  // Colors
  color: var(--textBlack);
  
  @media only screen and (max-width : 414px) {
    //font-size: 1rem;
  }
`;

//  - Created on July 29, 2020
const Date = styled.p`
  
  // Spacing
  margin: 0;
  padding: 0;
  
  // Font
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-1);
  line-height: 1.5;
  text-align: left;
  text-transform: uppercase;
  
  // Color
  color: var(--textRed);
  background-color: inherit;
  
  
    
`


export default NewsCard
